const e=async(e,t,n,r)=>{let{data:i}=await e.get(`/webhooks/${t}/${n}/${r}`);return i};export{e as getWebhook};
//# sourceMappingURL=get-webhook.mjs.map